import { useQuery } from '@tanstack/react-query';

import { myPracticeMembersKey, requestMyPracticeMembers } from './membersApi';

/** Thirty minutes: a practice roster changes on the order of days, and every member-selection
 * surface reads this same list. */
const ROSTER_STALE_TIME_MS = 30 * 60 * 1000;

/**
 * The provider's whole practice roster, fetched once and shared by every surface that picks a
 * member (the landing modal, the context-bar switcher).
 *
 * No `Failure` variant to handle: `myPracticeMembers` is a pure read, so infrastructure errors
 * travel the standard GraphQL errors envelope for the caller to read with `extractGqlErrorCode`.
 */
export function useMyPracticeMembers() {
  return useQuery({
    queryKey: myPracticeMembersKey,
    queryFn: requestMyPracticeMembers,
    staleTime: ROSTER_STALE_TIME_MS,
  });
}
